import { Overworld } from "./components/Overworld";
import "./App.scss";
import {useText} from "../src/fetchJSON"

function App() {
  let text = useText();
  return (
      <div className="gno">
        <Overworld 
          text={text} 
         />
      </div>
  );
}

export default App;
